import { SxProps, Theme } from '@mui/system';

const classes = {
  container: {
    display: 'flex',
    paddingTop: '12px',
    justifyContent: 'space-between',
  },

  labelFont: {
    color: '#8690AA',
    fontWeight: 400,
    fontSize: 13,
  },

  valueFont: {
    color: '#161C2C',
    fontSize: 14,
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginRight: '10px',
  },

  anchorFont: {
    color: 'primary.main',
    fontSize: 14,
    fontWeight: 500,
    marginRight: '10px',
    wordBreak: 'break-all',
    textDecoration: 'underline',
    '&:hover': {
      cursor: 'pointer',
    },
  },

  labelContainer: {
    flex: 2,
    textAlign: 'left',
  },

  anchorLabel: {
    mt: '3px',
  },

  valueContainer: {
    flex: 3,
    marginX: '5px',
    textAlign: 'left',
    minWidth: 0,
  },
} satisfies Record<string, SxProps<Theme>>;

export default classes;
